module.exports = __webpack_public_path__ + "static/media/AndroidTablet.b94fd564.png";